import { env } from "configs/EnvironmentConfig";
import fetchV2 from "auth/FetchInterceptorV2";

const orderRunnerService = {};

orderRunnerService.listOrderRunner = ({ runnerId, params }) => {
  const columnFilter = params.columnFilter || {};

  const defaultFields = [
    "id",
    "maker_id",
    "maker_date",
    "checker_id",
    "checker_date",
    "record_status",
    "type",
    "sale_name",
    "order_code",
    "transport_id",
    "orderDelivery.runner_id",
    "orderDelivery.receiver_info",
    "orderDelivery.sender_info",
    "status",
    "timeSlot.id",
    "timeSlot.name",
    "reciever_name",
    "reciever_full_address",
    "reciever_address",
    "reciever_ward_code",
    "reciever_district_code",
    "reciever_province_code",
    "reciever_contact_name",
    "reciever_contact_phone",
    "sender_name",
    "sender_full_address",
    "sender_address",
    "sender_ward_code",
    "sender_district_code",
    "sender_province_code",
    "sender_contact_name",
    "sender_contact_phone",
    "action_date",
    "from_hub",
    "to_hub",
  ];

  return fetchV2({
    url: `${env.API_MSP}/orders/${runnerId}/runner`,
    method: "get",
    params: {
      ...columnFilter,
      page: params.page || 1,
      "per-page": params.sizePerPage || 10,
      sort: params.sort || "-maker_date",
      keywords: params.keywords || "",
      expand: params.expand || "",
      fields: params.fields || defaultFields.join(","),
    },
  });
};

export default orderRunnerService;
